





































































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { Reimbursement } from "@/shared/types";
import Widget from "@/shared/components/Widget.vue";
import Button from "@/shared/components/ui/Button.vue";
import ReimbursedYearlySummary from "@/employee/components/healthcareExpense/ReimbursedYearlySummary.vue";
import ReimbursedRow from "@/employee/components/healthcareExpense/ReimbursedRow.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import SideBar from "@/employee/components/healthcareExpense/SideBar.vue";
import HealthcareExpenseNavigation from "@/employee/components/healthcareExpense/HealthcareExpenseNavigation.vue";
import HealthcareExpensesAdd from "@/employee/components/healthcareExpense/HealthcareExpensesAdd.vue";
import { useExpenseReimbursedStore } from "@/employee/store/expenseReimbursed";
import { useExpenseStore } from "@/employee/store/expense";

@Component({
  components: {
    Widget,
    Button,
    Pagination,
    ReimbursedRow,
    ReimbursedYearlySummary,
    SideBar,
    HealthcareExpenseNavigation,
    HealthcareExpensesAdd
  }
})
export default class HealthcareExpensesReimbursed extends Vue {
  reimbursedStore = useExpenseReimbursedStore();
  expenseStore = useExpenseStore();

  showExpenseAddView = false;

  mounted (): void {
    this.reimbursedStore.load();

    this.$on("tab-clicked", (event, tab) => {
      this.showExpenseAddView = false;
    });

    this.$on("close-add-expense", event => {
      this.showExpenseAddView = false;
    });
    this.expenseStore.getImportedExpenses();
  }

  get anyPages (): boolean {
    return this.reimbursedStore.hasPages;
  }

  get page (): number {
    return this.reimbursedStore.currentPage;
  }

  get numberOfPages (): number {
    return this.reimbursedStore.pageCount;
  }

  get rangeOfPages (): number[] {
    return this.reimbursedStore.pageRange;
  }

  get isCurrentPageEntirelySelected (): boolean {
    return this.reimbursedStore.currentPageSelected;
  }

  get numberOfReimbursements (): number {
    return this.reimbursedStore.totalNumberOfReimbursements;
  }

  onSwitchPage (pageNumber): void {
    this.reimbursedStore.loadPage({ page: pageNumber } as any);
  }

  getReimbursedList (): Reimbursement[] {
    return this.reimbursedStore.getExpensesList(this.page);
  }

  collapseRow (): void {
    this.getReimbursedList().forEach((element, index) => {
      this.$refs.row[index].collapseReimbursement();
    });
  }

  onAddClick (event: any) {
    event.preventDefault();
    this.showExpenseAddView = !this.showExpenseAddView;
  }

  get displayPilotExpenseTracker () {
    return this.expenseStore.importedExpenses.length > 0;
  }
}
